import { useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { signinSilentWithLock } from "../../utils/oidcSession";

export function useKeycloakToken() {
    const oidc = useAuth();

    return useCallback(
        async (options?: { forceRefresh?: boolean }) => {
            if (!oidc.user) {
                return null;
            }

            if (!options?.forceRefresh && !oidc.user.expired) {
                return oidc.user.access_token;
            }

            const renewedUser = await signinSilentWithLock(oidc);
            if (renewedUser) {
                return renewedUser.access_token;
            }

            await oidc.removeUser();
            void oidc.signinRedirect({
                state: {
                    returnTo: window.location.pathname + window.location.search,
                },
            });
            return null;
        },
        [oidc],
    );
}
